module.exports= class primative{
	constructor(index){
      this.name="";
      this.index=index;
      this.active=true;
			this.alive=true;
      this.belongsTo=null;
			this.enviroment=null;
			this.x=[];
			this.radius=0;
  }
}
